import Achyuth_Mohan from "./Achyuth_Mohan.jpg";
import Adam from "./Adam_(1).jpg";
import Anagha_Sivadas from "./Anagha_Sivadas.jpg";
import Arathy_Sha_A from "./Arathy_Sha_A.jpg";
import Athul_Reji from "./Athul_Reji.jpg";
import George_Sabu from "./George_Sabu.jpg";
import Hanna_Salam from "./Hanna_Salam.jpg";
import Hemanth_R from "./Hemanth_R.jpeg";
import Jagannath_E_Shahi from "./Jagannath_E_Shahi.jpeg";
import Jessica_Jolly from "./Jessica_Jolly.jpg";
import Jeswin from "./JESWIN_PHOTO.jpg";
import Lisa_VC from "./Lisa_VC.jpg";
import Mrinalini_Nair_Ani from "./Mrinalini_Nair_Ani.jpg";
import Nayana_Vinod from "./Nayana_Vinod.jpg";
import Neha_Mariam_Mathew from "./Neha_Mariam_Mathew.jpg";
import Nikita_menon from "./Nikita_Menon.jpg";
import SharatJacob from "./SharatJacob.jpeg";
import Shimil from "./Shimil.jpeg";
import Snehal_Sha from "./Snehal_Sha.jpg";
import Sony_P from "./Sony_P.jpeg";
import Sony_Thomas from "./Sony_Thomas.jpg";
import TomVempala from "./TomVempala.jpg";
import Vishruth_Subramanian from "./Vishruth_Subramanian.jpg";

import hanna from "./2023-24/Hanna Salam.png";
import jeswin from "./2023-24/Jeswin Thomas.png";
import sony from "./2023-24/Sony Thomas.png";
import arathy from "./2023-24/Arathy Sha.png";
import vignesh from "./2023-24/Vignesh S Naik.png";
import subru from "./2023-24/Subramani E.png";
import arpitha from "./2023-24/Arpitha Sudhir.png";
import alaka from "./2023-24/Alaka AJ.png";
import alex from "./2023-24/Alex Mathew Biju.png";
import adil from "./2023-24/Adil Naz Muhammed.png";
import neha from "./2023-24/Neha Mariam Mathew.png";

export {
  Achyuth_Mohan,
  Adam,
  Anagha_Sivadas,
  Arathy_Sha_A,
  Athul_Reji,
  George_Sabu,
  Hanna_Salam,
  Hemanth_R,
  Jagannath_E_Shahi,
  Jessica_Jolly,
  Jeswin,
  Lisa_VC,
  Mrinalini_Nair_Ani,
  Neha_Mariam_Mathew,
  Nayana_Vinod,
  Nikita_menon,
  SharatJacob,
  Shimil,
  Snehal_Sha,
  Sony_P,
  Sony_Thomas,
  TomVempala,
  Vishruth_Subramanian,
  hanna,
  jeswin,
  sony,
  arathy,
  vignesh,
  subru,
  arpitha,
  alaka,
  alex,
  adil,
  neha,
};
